module.exports = "/images/tag_e38aee.png";